export * from './SettingsSwitch';
export { default } from './SettingsSwitch';
